export const EmissionReportingConstants = {
    GET_ALL_EMISSION_REPORTING_SUCCESS: "GET_ALL_EMISSION_REPORTING_SUCCESS",
    GET_ALL_EMISSION_REPORTING_ERROR: "GET_ALL_EMISSION_REPORTING_ERROR",
    ALL_EMISSION_REPORTING_LOADING: "ALL_EMISSION_REPORTING_LOADING",
};
